<template>
  <div id="app">
    <Main :share_success="share_success"/>
    <Screen/>
  </div>
</template>

<script>
  import Main from "./components/Main.vue";
  import Screen from './components/screen'
  // import wechatShare from "./assets/js/share";
  import axios from 'axios'
  import wx from 'weixin-js-sdk'

  export default {
    name: "app",
    data() {
      return {
        share_success: 0,
      }
    },
    components: {
      Main,
      Screen
    },
    created() {
      this.wechatShare();
      this.isWechat();
    },
    methods: {
      jdShare() {
        var _this = this
        window.jdshare.setShareInfo({
          title: "618许愿时刻 全民狂欢",
          content: "点击神灯，许下愿望，你喜欢的都在这里",
          url:
            "https://idea.elloworld.cn/desirecity",
          img:
            "https://idea.elloworld.cn/desirecity/images/share.png",
          channel: "Wxfriends,Wxmoments,Sinaweibo",
          callback: function () {
            _this.share_success++;
            console.log('')
          },
          clickcallback: null,
          qrparam: null
        });
      },
      isWechat() {
        var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        var iswechat = ua.match(/MicroMessenger/i) == "micromessenger";
        // console.log(this.jdSource)
        // alert(iswechat)
        // wechatShare();
        if (iswechat) {
          this.wechatShare();
        } else {
          this.jdShare();
        }
      },

      wechatShare() {
        var _this = this
        axios.post('https://game.elloworld.cn/wxapi/index/getSignPackage').then((json) => {
          // success: function (json) {
          console.log(json)
          var res = json.data.data
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'hideOptionMenu']

          });
          wx.error(function (res) {
            // alert(JSON.stringify(res));
            console.log(res)
          });
        });
        var data = {
          title: "618许愿时刻 全民狂欢",
          desc: "点击神灯，许下愿望，你喜欢的都在这里",
          link:
            "https://idea.elloworld.cn/desirecity",
          imgUrl:
            "https://idea.elloworld.cn/desirecity/images/share.png",
        }
        console.log(data);

        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: ['getNetworkType', 'previewImage'],
            success: function (res) {
              console.log(JSON.stringify(res));
            }
          });

          wx.onMenuShareTimeline({
            title: data.title,
            link: data.link,
            imgUrl: data.imgUrl,
            success: function (res) {
              _this.share_success++
              _this.shareNum = 0
            },
            cancel: function (res) {
              console.log("已取消")
            }
          });

          wx.onMenuShareAppMessage({
            title: data.title,
            desc: data.desc,
            link: data.link,
            imgUrl: data.imgUrl,
            trigger: function (res) {
              console.log('用户点击发送给朋友');
            },
            success: function (res) {
              _this.share_success++
              _this.shareNum = 0
            },
            cancel: function (res) {
              console.log('已取消');
            },
            fail: function (res) {
              console.log(JSON.stringify(res));
            }
          });
        })
      }
    }
  };
</script>

<style lang="less">
  body,
  html {
    width: 100%;
    height: 100%;
    /*margin-top: -60px;*/
  }

  #app {
    width: 100%;
    height: 100%;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  * {
    margin: 0;
    padding: 0;
  }
</style>
